export const REQUESTED_VERSIONS = 'CANVAS/RESULTS/REQUEST_VERSIONS';
export const RECEIVED_VERSIONS = 'CANVAS/RESULTS/RECEIVED_VERSIONS';
export const REQUESTED_SAVE = 'CANVAS/RESULTS/REQUESTED_SAVE';
export const DONE_SAVE = 'CANVAS/RESULTS/DONE_SAVE';
export const TRIGGER_PUBLISH = 'CANVAS/RESULTS/TRIGGER_PUBLISH';
export const CREATE_DRAFT = 'CANVAS/RESULTS/CREATE_DRAFT';
export const EDIT_RULE = 'CANVAS/RESULTS/EDIT_RULE';
export const SET_VALUE = 'CANVAS/RESULTS/SET_VALUE';
export const CANCEL_CREATE_DRAFT = 'CANVAS/RESULTS/CANCEL_CREATE_DRAFT';